export default "__VITE_ASSET__BPLII9Va__"